import { Col, Form, Row } from 'react-bootstrap';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import RadioInput from 'src/Member/components/common/radio';
import './AffiliateAccount.scss';

const AffiliateAccount = (props) => {
  const {
    //isDefaultMemberType,
    isDefaultMemberIdType,
    //handleDefaultUserType,
    handleDefaultSelectionType,
    ssnValue,
    setSsnValue,
    memberId,
    setMemberId,
    handleSearchButton,
  } = props;

  return (
    <div className="affiliate-account-additionalinfo-container">
      <Row className="additional-info-text pt-2 m-0">
        Your additional information
      </Row>
      <Row className="pt-4">
        <Col xs={4} sm={2} md={2} lg={2} className="label-text">
          Select Type
          <span className="form-required" aria-hidden={true}>
            *
          </span>
        </Col>
        <Col xs={4} sm={2} md={2} lg={2}>
          <RadioInput
            id="defaultSelectionType"
            label="Member ID"
            name="selectionType"
            value="memberID"
            checked={isDefaultMemberIdType}
            onChange={handleDefaultSelectionType}
          />
        </Col>
        <Col xs={4} sm={2} md={2} lg={2}>
          <RadioInput
            id="ssnSelectionType"
            label="SSN"
            name="selectionType"
            value="ssn"
            checked={!isDefaultMemberIdType}
            onChange={handleDefaultSelectionType}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12} sm={2} md={2} lg={6} className="pt-4">
          {isDefaultMemberIdType ? (
            <Form>
              <Form.Group controlId="reg_memberID">
                <Form.Label class="sr-only">Member ID</Form.Label>
                <Form.Control
                  type="text"
                  name="memberId"
                  placeholder="Enter Member ID"
                  className=""
                  value={memberId || ''}
                  onChange={(e) => {
                    //handleChange(e);
                    const storeSSN = e.currentTarget.value;
                    setMemberId(storeSSN);
                  }}
                  autoCorrect="off"
                  spellCheck="off"
                  autoComplete="off"
                  aria-required={true}
                />
              </Form.Group>
            </Form>
          ) : (
            <Form>
              <Form.Group controlId="reg_SSN">
                <Form.Label class="sr-only">SSN</Form.Label>
                <Form.Control
                  type="text"
                  name="ssn"
                  placeholder="Enter SSN"
                  className=""
                  value={ssnValue || ''}
                  onChange={(e) => {
                    //handleChange(e);
                    const storeSSN = e.currentTarget.value;
                    const SSNValue = storeSSN.replace(/-/g, '');
                    setSsnValue(SSNValue);
                  }}
                  autoCorrect="off"
                  spellCheck="off"
                  autoComplete="off"
                  aria-required={true}
                />
              </Form.Group>
            </Form>
          )}
        </Col>
      </Row>
      <Row className="m-0">
        <Col
          xs={12}
          sm={2}
          md={2}
          lg={6}
          className="d-flex justify-content-end pt-4"
        >
          <GenericButton
            type="submit"
            className=""
            ariaLabel="Click to search affiliations"
            onClick={() => {
              handleSearchButton();
            }}
            postLabel={'SEARCH'}
            buttonDisabled={true}
            disable={
              isDefaultMemberIdType
                ? memberId?.length === 0
                : ssnValue?.length === 0
            }
          >
            SEARCH
          </GenericButton>
        </Col>
      </Row>
    </div>
  );
};

export default AffiliateAccount;
